import type { CatalogFile } from '../types/catalog';

export const STORAGE_KEY = 'prevdrive-catalogs';
export const PENDING_KEY = 'prevdrive-pending-ops';
export const REMOTE_MAP_KEY = 'prevdrive-remote-map';

export interface PendingOp {
  id: string;
  type: 'add' | 'remove';
  key: string;
  catalog?: CatalogFile;
  timestamp: number;
  retries: number;
}

export function saveCatalogs(entries: Array<[string, CatalogFile]>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    // localStorage pode estar indisponível
  }
}

export function loadCatalogs(): Array<[string, CatalogFile]> {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? (JSON.parse(data) as Array<[string, CatalogFile]>) : [];
  } catch {
    return [];
  }
}

export function saveRemoteMap(entries: Array<[string, string]>): void {
  try {
    localStorage.setItem(REMOTE_MAP_KEY, JSON.stringify(entries));
  } catch {
    // silent
  }
}

export function loadRemoteMap(): Array<[string, string]> {
  try {
    const data = localStorage.getItem(REMOTE_MAP_KEY);
    return data ? (JSON.parse(data) as Array<[string, string]>) : [];
  } catch {
    return [];
  }
}

export function savePendingOps(ops: PendingOp[]): void {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(ops));
  } catch {
    // silent
  }
}

export function loadPendingOps(): PendingOp[] {
  try {
    const data = localStorage.getItem(PENDING_KEY);
    return data ? (JSON.parse(data) as PendingOp[]) : [];
  } catch {
    return [];
  }
}